import React from "react";
import Sidebar from "../Components/Sidebar";
import SmsBlendCalculator from "../Components/SmsBlendCalculator";

const SmsBlendOptimizer = () => {
  return (
    <Sidebar>
      <div className="container-fluid">
        <SmsBlendCalculator />
      </div>
    </Sidebar>
  );
};

export default SmsBlendOptimizer;
